<template>
  <div class="app-content">
    <AppPageTitle></AppPageTitle>
    <Content class="app-content__main">
      <Row>
        <Col :md='24' style="margin-bottom: 20px">
          <SelectAgent
            @selectAgentSuccess="selectAgentSuccess"
            @selectAgentClear="selectAgentClear" />
          <Button
            type="primary"
            icon="md-add"
            style="margin-left: 8px"
            @click="createItem"
          >新增</Button>
        </Col>
      </Row>
      <Table
        :columns="queryColumn"
        :loading="loading"
        :data="queryData"
        border
        ref="dataTable"
      >
        <template slot-scope="{row}" slot="useState">
          <Tag color="cyan" v-if="row.status === 2">已激活</Tag>
          <Tag color="red" v-else>已暂停</Tag>
        </template>
        <template slot-scope="{row}" slot="offer">
          {{row.elementType}} {{row.offerId}}
        </template>
        <template slot-scope="{row}" slot="createTime">
          {{row.createTime | formatDate}}
        </template>
        <template slot-scope="{row}" slot="action">
          <Button
            type="text"
            class="text-link"
            size="small"
            @click="updateItem(row)"
          >编辑</Button>
          <Button
            v-if="row.status === 2"
            type="text"
            class="text-link"
            size="small"
            icon="md-pause"
            @click="statusItem(row)"
          >暂停</Button>
          <Button
            v-else
            type="text"
            class="text-link"
            size="small"
            icon="md-play"
            @click="statusItem(row)"
          >激活</Button>
        </template>
      </Table>
      <Row>
        <Col :md="24" class="pagination">
          <Page
            :total="totalPage"
            :page-size="pageSize"
            :current="pageNum"
            :disabled="loading"
            @on-change="pageChange"
            @on-page-size-change="pageSizeChange"
            show-elevator show-sizer show-total />
        </Col>
      </Row>
    </Content>
    <AddBox ref="agentApiCreateUpdate" @success="createUpdateSuccess"></AddBox>
  </div>
</template>

<script>
import api from '@/api'
import AddBox from './Add.vue'
import SelectAgent from '@/components/agent/selectAgent.vue'

export default {
  components: {
    SelectAgent,
    AddBox
  },
  filters: {
    formatDate: function (value) {
      let date = new Date(+value)
      let y = date.getFullYear()
      let MM = date.getMonth() + 1
      MM = MM < 10 ? ('0' + MM) : MM
      let d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      let h = date.getHours()
      h = h < 10 ? ('0' + h) : h
      let m = date.getMinutes()
      m = m < 10 ? ('0' + m) : m
      let s = date.getSeconds()
      s = s < 10 ? ('0' + s) : s
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
    }
  },
  data () {
    return {
      queryData: [],
      loading: false,
      totalPage: 1,
      pageSize: 10,
      pageNum: 1,
      agentId: ''
    }
  },
  computed: {
    queryColumn () {
      return [
        {
          title: '供应商编号',
          key: 'agentId',
          align: 'center',
          minWidth: 150
        },
        {
          title: '供应商名称',
          key: 'agentName',
          align: 'center',
          minWidth: 120
        },
        {
          title: '产品ID',
          key: 'offerId',
          align: 'center',
          slot: 'offer',
          minWidth: 120
        },
        {
          title: '关联商品',
          key: 'bindGoodName',
          align: 'center',
          minWidth: 120
        },
        {
          title: '激活状态',
          key: 'useState',
          minWidth: 100,
          slot: 'useState',
          align: 'center'
        },
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 100,
          slot: 'createTime',
          align: 'center'
        },
        {
          title: '操作',
          key: 'id',
          minWidth: 120,
          slot: 'action',
          align: 'center'
        }
      ]
    }
  },
  methods: {
    getData () {
      this.loading = true
      api.supplier.supplierCommodityList({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        id: this.agentId
      })
        .then((res) => {
          this.loading = false
          this.totalPage = +res.data.total
          this.queryData = res.data.records || []
        })
        .catch((err) => {
          this.loading = false
          this.$Message.error('获取代理商接口权限列表失败: ' + err.message)
        })
    },
    // 新增
    createItem () {
      this.$refs.agentApiCreateUpdate.show('create')
    },
    // 修改
    updateItem (item) {
      this.$refs.agentApiCreateUpdate.show('update', item)
    },
    pageChange (pageNum) {
      this.pageNum = pageNum
      this.getData()
    },
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.pageNum === 1 ? this.getData() : this.pageNum = 1
    },

    // 组件选中
    selectAgentSuccess (val) {
      this.agentId = val.value
      this.pageNum = 1
      this.getData()
    },
    // 组件清空
    selectAgentClear () {
      this.agentId = null
      this.queryData = []
      this.getData()
    },
    // 暂停/激活
    statusItem (row) {
      const stateText = row.status === 2 ? '暂停' : '激活'
      this.$Modal.confirm({
        title: stateText + '确认',
        content: `<p>您确定${stateText}此代理商对产品[<span class="text-danger">${row.elementType} ${row.offerId}</span>]的授权状态吗？</p>
                    <p><small class="text-danger">注：${stateText}后，代理商产品变更将会被${row.status ? '拒绝' : '允许'}。</small></p>`,
        loading: true,
        onOk: () => {
          api.supplier.supplierCommodityUpdate({
            id: row.id,
            status: row.status === 2 ? 1 : 2
          })
            .then(() => {
              this.$Modal.remove()
              if (!(this.queryData.length - 1)) {
                this.pageNum = this.pageNum - 1 ? this.pageNum - 1 : 1
              }
              this.getData()
              this.$Message.success(`${stateText}成功!`)
            })
            .catch((err) => {
              this.$Modal.remove()
              this.$Modal.error({
                title: '抱歉',
                content: `${stateText}失败: ` + err.message
              })
            })
        }
      })
    },
    // 新增，编辑成功
    createUpdateSuccess () {
      this.getData()
    }
  },
  created () {
    this.getData()
  }
}
</script>
